import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Markdown from "markdown-to-jsx";

import { Language } from "../../../utils";
import { user as userActions } from "../../../actions";
import { Button } from "../../../components";
import PaymentPlansModal from "../../../components/PaymentPlansModal";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Checkbox, InputLabel } from "@material-ui/core";
import makeClasses from "../styles";
import clsx from "clsx";

const StepNine = ({ history, nextStep, prevStep, traceId, stepOneData }) => {
  const dispatch = useDispatch();
  const classes = makeClasses();

  const { loading, languageTexts } = useSelector((state) => ({
    loading: state.user.loading,
    languageTexts: state.language.texts || {},
  }));

  const i18n = Language(languageTexts);

  const [paymentPlans, setPaymentPlans] = useState([]);
  const [inputPaymentPlan, setInputPaymentPlan] = useState(null);
  const [acceptedHandyTyC, setAcceptedHandyTyC] = useState(false);
  const [acceptedPaigoTyC, setAcceptedPaigoTyC] = useState(false);
  const [plansModalOpen, setPlansModalOpen] = useState(false);

  const canMoveToNext =
    inputPaymentPlan !== null && acceptedHandyTyC && acceptedPaigoTyC;

  useEffect(() => {
    dispatch(
      userActions.getPaymentPlans((plans) => {
        setPaymentPlans(plans);
      }),
    );
  }, [dispatch]);

  const _getOptionLabel = (option) => {
    const found = paymentPlans.find((p) => p.id === option);
    return found ? found.name : "";
  };

  const handleNext = () => {
    if (!inputPaymentPlan) {
      return toast.error(
        i18n.get("LegalEntityRegistration.RegisterInvalidPaymentPlan"),
        { autoClose: 5000 },
      );
    }
    if (!acceptedHandyTyC || !acceptedPaigoTyC) {
      return toast.error(
        i18n.get("LegalEntityRegistration.RegisterInvalidTyC"),
        { autoClose: 5000 },
      );
    }

    dispatch(
      userActions.merchantAffiliationPaymentPlanData(
        traceId,
        inputPaymentPlan,
        (result) => {
          if (result === "ok") {
            nextStep();
          }
        },
      ),
    );
  };

  return (
    <React.Fragment>
      <div className={classes.formContent}>
        <div className={classes.formTitleContainer}>
          <div className={classes.formTitle}>
            {i18n.get("LegalEntityRegistration.StepFormTitle")}
          </div>
          <div className={classes.formText}>
            {i18n.get("LegalEntityRegistration.Step7FormText")}
          </div>
        </div>
        <form layout="vertical" onSubmit={handleNext} className={classes.form}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <InputLabel className={classes.formLabel}>
                {i18n.get("LegalEntityRegistration.InputPaymentPlans")}
              </InputLabel>
              <Autocomplete
                options={paymentPlans.map((p) => p.id)}
                getOptionLabel={_getOptionLabel}
                onChange={(e, newValue) => setInputPaymentPlan(newValue)}
                classes={{ inputRoot: classes.formInputSelect }}
                value={inputPaymentPlan}
                renderInput={(params) => (
                  <TextField
                    className={classes.formInput}
                    classes={{ root: classes.formInput }}
                    variant="outlined"
                    placeholder={i18n.get(
                      "LegalEntityRegistration.InputPaymentPlans",
                    )}
                    {...params}
                  />
                )}
              />
            </Grid>
            <Grid
              item
              xs={12}
              className={classes.viewPaymentPlansButtonContainer}>
              <Button
                className={classes.viewPaymentPlansButton}
                variant="text-only"
                onClick={() => setPlansModalOpen(true)}>
                {i18n.get("LegalEntityRegistration.ViewPaymentPlans")}
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
      <div className={classes.termsWrapper}>
        <div
          className={classes.termsContainer}
          style={{ justifyContent: "flex-start" }}>
          <Checkbox
            classes={{ root: classes.checkboxRoot }}
            checked={acceptedHandyTyC}
            onChange={() => setAcceptedHandyTyC(!acceptedHandyTyC)}
          />
          <Markdown className={classes.termsLabel}>
            {i18n.get("LegalEntityRegistration.HandyTyC")}
          </Markdown>
        </div>
        <div
          className={classes.termsContainer}
          style={{ justifyContent: "flex-start" }}>
          <Checkbox
            classes={{ root: classes.checkboxRoot }}
            checked={acceptedPaigoTyC}
            onChange={() => setAcceptedPaigoTyC(!acceptedPaigoTyC)}
          />
          <Markdown className={classes.termsLabel}>
            {i18n.get("LegalEntityRegistration.PaigoTyCLabel")}
          </Markdown>
        </div>
        <div
          className={clsx(
            classes.formSubmitContainer,
            classes.formSubmitContainerWithOneButton,
            classes.formSubmitContainerWithNoMargin,
          )}>
          <Button
            className={classes.formSubmitButton}
            disabled={loading || !canMoveToNext}
            onClick={handleNext}>
            {i18n.get("LegalEntityRegistration.NextButton")}
          </Button>
        </div>
      </div>
      <PaymentPlansModal
        open={plansModalOpen}
        onClose={() => setPlansModalOpen(false)}
      />
    </React.Fragment>
  );
};

StepNine.id = "com.Handy.LegalEntityRegistration.StepNine";
export default StepNine;
